<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM17.9843 7.39079C18.1986 6.64478 17.4974 5.94358 16.7513 6.15787L16.6494 6.19284L9.57836 9.02127L9.47282 9.0708C9.30957 9.15937 9.17429 9.29167 9.0821 9.45256L9.02127 9.57836L6.19284 16.6494L6.15787 16.7513C5.94358 17.4974 6.64478 18.1986 7.39079 17.9843L7.49271 17.9493L14.5638 15.1209L14.6693 15.0713C14.8326 14.9828 14.9678 14.8505 15.06 14.6896L15.1209 14.5638L17.9493 7.49271L17.9843 7.39079ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
    fill="currentColor"
  />
</svg>
